<template>
	<div class="ProductSale">
		<div class="wrapper" ref="scroll-container">
			<!-- 상품 소개 (상세 헤더) -->
			<product-list-item :item="catalog" mode="sale" variant="detail" />

			<!-- 구매 옵션: SKU / 옵션 / 가격 / 출고정보 -->
			<section class="sale-section">
				<div class="section-head">
					<h3>구매 옵션</h3>
					<span class="section-count" v-if="list.length > 0">총 {{ list.length }}개</span>
				</div>
				<seller-list :list="list" />
			</section>
		</div>
	</div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import MixinScrolling from '@/mixins/scrolling'
import ProductListItem from '@/components/item/ProductListItem.vue'
import SellerList from '@/views/product/components/SellerList.vue'
import cookies from 'vue-cookies'

export default {
	name: 'ProductSale',
	components: {
		ProductListItem,
		SellerList,
	},
	mixins: [MixinScrolling],
	data() {
		return {
			loadingHandler: null,
			list: [],
			catalogId: this.$route.params.id,
			hasStock: false,
			offset: 0,
			length: 30,
			order: ['FAVORITE'],
			orderDirection: ['DESC'],
			sellerIds: [],
		}
	},
	computed: {
		...mapState('catalog', ['catalog', 'productList', 'productFilter']),
		...mapState('delivery', ['basicAddress']),
		...mapGetters('user', ['instituteId']),
		sellerList() {
			const list = []
			this.productFilter.seller?.forEach(seller => {
				list.push({ name: seller.name, value: seller.id })
			})
			return list
		},
		filterList() {
			const filters = {}
			filters.filterSellerList = this.sellerList
			return filters
		},
		sortTabList() {
			const list = []
			list.push({ id: 1, value: 'FAVORITE', direction: 'DESC', name: '구매 많은순' })
			list.push({ id: 2, value: 'PRICE', direction: 'ASC', name: '낮은 가격순' })
			list.push({ id: 3, value: 'PRICE', direction: 'DESC', name: '높은 가격순' })
			return list
		},
		currentAddressId() {
			return cookies.get('currentAddress2')?.id ?? this.basicAddress?.id
		},
		currentInstituteId() {
			return cookies.get('currentInstitute2')?.id ?? this.instituteId
		},
	},
	watch: {
		async isBottom(val) {
			if (!val) return

			if (this.offset < this.list.length && this.productList.count > this.list.length) {
				this.offset = this.offset + this.length

				await this.fetchProductList()
				if (this.productList.list.length > 0) {
					this.list = [...this.list, ...this.productList.list]
				}
			}
		},
		instituteId: {
			async handler(newVal) {
				await this.fetchCatalog()
				await this.fetchProductList()
				await this.fetchProductListFilter()

				this.list = this.productList.list
			},
			immediate: true,
		},
	},
	methods: {
		...mapActions('catalog', ['lookupCatalog', 'lookupProductList', 'lookupProductListFilter']),
		async fetchCatalog() {
			const params = {}
			if (this.currentAddressId) params.deliveryId = this.currentAddressId
			if (this.currentInstituteId) params.instituteId = this.currentInstituteId
			await this.lookupCatalog({ id: this.catalogId, params })
		},
		async fetchProductList() {
			const params = {
				catalogId: this.catalogId,
				hasStock: this.hasStock,
				offset: this.offset,
				sellerIds: this.sellerIds,
				length: this.length,
				order: [this.order],
				orderDirection: this.orderDirection,
			}

			if (this.currentAddressId) params.deliveryId = this.currentAddressId
			if (this.currentInstituteId) params.instituteId = this.currentInstituteId
			await this.lookupProductList(params)
		},
		async fetchProductListFilter() {
			const params = {
				catalogId: this.catalogId,
				hasStock: this.hasStock,
			}
			await this.lookupProductListFilter(params)
		},
		//select filter list 가져오기
		setSelectedFilter(list) {
			this.offset = 0
			this.sellerIds = []
			list.forEach(item => {
				this.sellerIds.push(item.value)
			})
			this.fetchProductList()
		},
		async sortProduct(key) {
			this.order = key.value
			this.orderDirection = [key.direction]
			await this.fetchProductList()

			this.list = this.productList.list
		},
		async changeStock(bool) {
			this.hasStock = bool
			await this.fetchProductList()

			this.list = this.productList.list
		},
	},
}
</script>

<style lang="scss">
.ProductSale {
	.wrapper {
		padding: 28px 0 80px;
	}

	.product-list-item {
		border-bottom: 0;
	}

	/* 구매 옵션 섹션 */
	.sale-section {
		margin-top: 40px;

		.section-head {
			display: flex;
			align-items: baseline;
			gap: 12px;
			margin-bottom: 14px;

			h3 {
				margin: 0;
				padding-left: 12px;
				border-left: 4px solid #2563eb;
				font-size: 1.3rem;
				line-height: 1.2;
				font-weight: 800;
				color: #111827;
			}
			.section-count {
				font-size: 0.85rem;
				color: #7a8591;
			}
		}
	}

	.seller-table {
		border: 1px solid #e6eaee;
		border-radius: 14px;
		overflow: hidden;
		background: #fff;

		table {
			border-collapse: collapse;
			table-layout: fixed;
		}

		thead {
			height: auto !important;
			padding: 0 !important;
			border: 0 !important;
			background: #f6f8fa;

			th {
				padding: 14px 20px !important;
				font-size: 0.82rem;
				font-weight: 700;
				color: #6b7785;
				text-align: left;

				&:before,
				&:after {
					display: none !important;
				}
				&:nth-child(1) {
					width: 22%;
				}
				&:nth-child(2) {
					width: 28%;
				}
				&:nth-child(3) {
					width: 22%;
				}
				&:nth-child(4) {
					width: 28%;
				}
			}
		}

		tbody tr.table-item {
			border-bottom: 1px solid #eef1f4;
			transition: background-color 0.15s;

			&:last-child {
				border-bottom: 0;
			}
			&:hover {
				background: #f4f8ff;

				td:first-child {
					box-shadow: inset 3px 0 0 #2563eb;
				}
			}

			td {
				padding: 20px !important;
				vertical-align: middle;
				font-size: 0.95rem;
				color: #1f2933;
			}

			/* SKU */
			td.sku {
				font-size: 1rem;
				font-weight: 800;
				letter-spacing: 0.01em;
			}

			/* 옵션 */
			td.sellerOption p {
				margin: 0;
				line-height: 1.5;
				color: #4a5764;
			}

			/* 가격 */
			.sale-price-box {
				display: flex;
				flex-direction: column;
				align-items: flex-start;
				gap: 2px;

				.sale-origin-row {
					display: flex;
					align-items: baseline;
					gap: 6px;
				}
				.sale-discount {
					font-style: normal;
					font-size: 0.95rem;
					font-weight: 900;
					color: #ef4444;
				}
				.sale-origin {
					font-size: 0.85rem;
					color: #9aa4af;
				}
				.sale-price {
					margin: 0;
					font-size: 1.25rem;
					font-weight: 800;
					color: #111827;
				}
				.lowest-badge {
					display: inline-block;
					margin-left: 8px;
					padding: 2px 9px;
					border-radius: 10px;
					background: #fff1f0;
					color: #e5484d;
					font-size: 0.72rem;
					font-weight: 800;
					vertical-align: middle;
				}
				.sale-inquiry {
					display: inline-flex;
					align-items: center;
					height: 32px;
					margin: 0;
					padding: 0 14px;
					border: 1px solid #bcd6ee;
					border-radius: 16px;
					background: #eaf3fb;
					color: #1d4f80;
					font-size: 0.9rem;
					font-weight: 800;
				}
			}

			/* 출고정보 */
			td.sellerShipping {
				.ship-main {
					font-size: 0.95rem;
					font-weight: 700;
					color: #1d4f80;
				}
				.ship-sub {
					font-size: 0.9rem;
					color: #98a2ad;
				}
				.sack-info {
					display: inline-flex;
					align-items: center;
					gap: 4px;
				}
			}
		}
	}
}
</style>
